<template>
  <div class="verification-details-company-info">
    <template v-if="verification.isNotEmptySumsubKyc">
      <a-collapse
        active-key="verification-details-applicant-info.key-info"
        force-render="true"
        expand-icon-position="right">
        <a-collapse-panel
          key="verification-details-applicant-info.key-info"
          :header="'verification-details-applicant.title' | globalize">
          <details-reader
            :with-accordion="true"
            :details="applicantInfo" />

          <a-table
            size="small"
            :data-source="flatDocs"
            :row-key="record=>record.id"
            :pagination="false"
            :columns="columns">
            <template
              slot="url-column"
              slot-scope="url,record">
              <div class="verification-details-photos__img-wrp">
                <img
                  v-auth-image.src="`${url}`"
                  :title="record.id"
                  @click="selectPhotoUrl"
                  class="app__img-preview">
              </div>
            </template>
          </a-table>
        </a-collapse-panel>
      </a-collapse>

      <photo-viewer
        :img-url="selectedDocUrl"
        :is-shown.sync="isImageViewerShown"
      />
    </template>
    <template v-else>
      {{ 'verification-details-applicant.empty-data-on-provider' | globalize }}
    </template>
  </div>
</template>

<script>
import { globalize } from '@/vue/filters/globalize'
import { VerificationRecord } from '@/js/records/entities/verification.record'
import DetailsReader from '@/vue/common/DetailsReader/DetailsReader'
import ATable from 'ant-design-vue/lib/table'
import ACollapse from 'ant-design-vue/lib/collapse/Collapse'
import ACollapsePanel from 'ant-design-vue/lib/collapse/CollapsePanel'
import config from '@/config'
import Country from '@/vue/common/country/Country'
import PhotoViewer from '@/vue/common/PhotoViewer'

function imageUrl (inspectionId, imageId) {
  if (/\/$/.test(config.API_URL)) {
    return `${config.API_URL}sumsub/docs/${inspectionId}/${imageId}`
  }
  return `${config.API_URL}/sumsub/docs/${inspectionId}/${imageId}`
}

const columns = ctx => {
  /* eslint-disable-next-line */
  const h = ctx.$createElement
  return [
    {
      dataIndex: 'id',
      key: 'id',
      title: globalize('verification-details-company.lbl-doc-type-id'),
    },
    {
      dataIndex: 'reviewResult',
      key: 'reviewResult',
      title: globalize('user-data.review-result'),
    },
    {
      dataIndex: 'country',
      key: 'country',
      title: globalize('user-data.country'),
      customRender: (text) => {
        return <Country code={text}/>
      },
    },
    {
      dataIndex: 'url',
      key: 'url',
      title: 'URL',
      scopedSlots: { customRender: 'url-column' },
    },
  ]
}

export default {
  name: 'verification-details-sumsub-applicant-info',
  components: {
    DetailsReader,
    'a-collapse': ACollapse,
    'a-collapse-panel': ACollapsePanel,
    ATable,
    PhotoViewer,
  },
  props: {
    verification: {
      type: VerificationRecord,
      required: true,
    },
    applicantInfo: {
      type: Object,
      required: true,
    },
    docs: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      selectedDocUrl: '',
      isImageViewerShown: false,
    }
  },
  computed: {
    columns () {
      const result = columns(this)

      return result
    },
    flatDocs () {
      const { inspectionId } = this.applicantInfo

      const flatList = []

      this.docs.forEach(doc => {
        doc.imageId && doc.imageId.forEach(imageId => {
          const row = {
            url: imageUrl(inspectionId, imageId),
            group: doc.id,
            ...doc,
          }

          flatList.push(row)
        })
      })

      return flatList
    },
  },
  methods: {
    selectPhotoUrl (ev) {
      this.selectedDocUrl = ev.target.attributes.src.value
      this.isImageViewerShown = true
    },
  },
}
</script>

<style lang="scss">
  @import '~@scss/variables';
  @import '~ant-design-vue/lib/collapse/style/index.css';
</style>
